export default __webpack_public_path__ + "static/media/icon_home_top_setting.503782c4.svg";